import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeadersInterceptor implements HttpInterceptor {

  headers!: HttpHeaders;

  headersNoToken!: HttpHeaders;

  headersImg!: HttpHeaders;

  token: string | null = '';

  reqClone: any;

  constructor() { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //Declaramos el token para añadirlo a los headers
    this.token = localStorage.getItem('token');
    this.reqClone = req;
    
    //Declaramos los headers que se usaran en el login o recuperación de contraseña
    //this.headersNoToken = new HttpHeaders().set('Content-Type', 'application/json').set('X-Requested-With', 'XMLHttpRequest').set('api_key', 'metrica');
    //Declaramos los headers que se enviaran en la petición que necesite el token
    //this.headers = new HttpHeaders();
    if (!req.url.includes('api.copomex.com')){
          this.headers = new HttpHeaders().set('Authorization', `Bearer ${this.token}`);
          this.reqClone = req.clone({
            headers: this.headers
          });
    }
    //Declaramos los headers que se envían en una petición a subir imágenes o archivos
    // this.headersImg = new HttpHeaders().set('Accept', 'application/json').set('Authorization', 'Bearer ' + this.token).set('api_key', 'metrica');
    //Declaramos la variable que tendrá los headers
    return next.handle(this.reqClone)
  }

}
